<template>
  <div :id="targetId" v-if="inlineSearch"></div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'Feratelsearch',
    props: {
        target: {
            String,
            default: null
        },
        appId: {
            type: String,
            required: true
        },
        appName: {
            type: String,
            required: true
        },
        locationId: {
            type: String,
            required: true
        },
        locationType: {
            type: String,
            required: true
        },
        dates: {
            type: Object,
            required: true
        },
        units: {
            type: Array,
            required: true
        },

        lang: {
            type: String,
            default: 'de'
        }

    },

    data() {
        return {
            dw: null,
            inlineSearch: false,
            targetId: this.target
        }
    },

    methods: {

        search() {
            this.pop = false
            var qfsettings = {}
            qfsettings.dateFrom = this.checkin
            qfsettings.dateTo = this.checkout
            qfsettings.urlParams = `lkRG=${this.locationType}&lkID=${this.locationId}`

            this.units.forEach((unit, i) => {
                let n = i+1
                qfsettings['occupancy' + n] = {
                    units: 1,
                    adults: unit.adults,
                    children: unit.children
                }
            });
            // qfsettings.occupancy1 = {}
            // qfsettings.occupancy1.units = this.units.length
            // qfsettings.occupancy1.adults = this.units[0].adults
            // qfsettings.occupancy1.children = this.units[0].children

            if (this.targetIsUrl) {
                this.sendGET(qfsettings)
            } else {
                this.inlineSearch = true
                if (this.target === null) {
                    this.targetId = "t5panel-" + Math.floor(Math.random()*10000)
                }
                this.showInlineResult(qfsettings)
            }

        },

        sendGET(qfsettings) {

            var querystring = qfsettings.urlParams;
            querystring += '&selNumberOfUnits=' + this.units.length;
            querystring += '&selNights=' + this.nights;
            querystring += '&selArrivalDate=' + (moment(this.checkin).format('YYYYMMDD'));
            this.units.forEach((unit, i) => {
                let n = i+1
                querystring += '&selAdultsSearchLine' + n + '=' + unit.adults;
                if (Array.isArray(unit.children) && unit.children.length > 0) {
                    querystring += '&selChildrenSearchLine' + n + '=' + unit.children.join(',')
                }
            });

            var requestUrl = this.target;
            // querystring im target vorhanden?
            if (/\?/.test(requestUrl)) {
                requestUrl += '&' + querystring;
            } else {
                requestUrl += '?' + querystring;
            }
            window.location.href = requestUrl;
        },

        showInlineResult (qfsettings) {
            this.dw = this.dw || window.dw || function () { (dw.q = dw.q || []).push(arguments) };
            if (typeof this.dw.destroyTag != "undefined") {
                this.dw.destroyTag(this.appId);
            }
            this.dw('settings', this.appId,
                {
                    "context": {
                        "urlOptionalParams": qfsettings.urlParams
                    },
                    "lang": this.lang,
                    "target": this.targetId,
                    "loadingAnimationColor": {
                        "main": '#0073B6',
                        "alt": '#F2F2F2'
                    },
                    "profileOverrides": [
                        "general.header.visible=false",
                        "general.navigation.visible=false"
                    ]
                });

            this.dw.accommodationQuickFind(
                'kaernten',
                qfsettings,
                this.loadapp()
            )
        },

        loadapp() {

                var script = document.createElement('script');
                script.src = "https://resc.deskline.net/DW5/start/"
                        + this.appName + "/"
                        + this.appId +"/index.js";
                document.head.appendChild(script);
        },

        strIsUrl (str) {
            var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            return expression.test(str);

        }

    },

    computed: {
        targetIsUrl: function () {
            return this.strIsUrl(this.target)
        },

        checkin: function () {
            if (!this.dates.checkin) return null
            return moment(this.dates.checkin).startOf('day').toDate()
        },

        checkout: function () {
            if (!this.dates.checkout) return null
            return moment(this.dates.checkout).startOf('day').toDate()
        },


        nights: function() {
            if (this.checkin !== null  && this.checkout !== null) {
                return moment(this.checkout).diff(moment(this.checkin), 'days')
            }
            return 1;
        }
    },

    watch: {
        target: function (newVal, oldVal) {
            if (this.targetIsUrl) return;

        }
    },

    mounted() {

        if (typeof dw !== 'undefined') return;

        var script = document.createElement('script');
        script.src = "https://web5.deskline.net/dwutility.js";
        document.head.appendChild(script);
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Feratelsearch.vue